import { apiBaseKeys } from 'core/api/api.routes';
import { usePocQuery } from 'core/custom-hooks/usePocQuery';
import { getSupportedLanguages } from './api/api';

export const useLanguages = () => {
  // getSupportedLanguages never rejects (it falls back to the bundled list), so consumers
  // gating on isFetched need no error path.
  const { data: languages = [], isFetched } = usePocQuery({
    queryKey: [apiBaseKeys.languages],
    queryFn: getSupportedLanguages,
    staleTime: Infinity,
  });

  return { languages, isFetched };
};
